import ScanWallet from './ScanWallet.jsx';

export default ScanWallet;